import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

// Modules Material utilises
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';

// Autres modules externes utilises 
import { NgxFileDropModule } from 'ngx-file-drop';
import { FiltersModule } from '../../ui-modules/filters/filters.module';
import { FormattersModule } from '../../ui-modules/formatters/formatters.module';

// Modules metiers utilises
import { AgenceModule } from '../structure/agence/agence.module';
import { AntenneModule } from '../structure/antenne/antenne.module';
import { GroupementParcModule } from '../structure/groupement-parc/groupement-parc.module';
import { OuvrageModule } from '../structure/ouvrage/ouvrage.module';
import { ParcModule } from '../structure/parc/parc.module';

// Modules communs utilises
import { BootstrapPopupModule } from '../../shared/bootstrap-popup/bootstrap-popup.module';
import { CheckboxListModule } from '../../shared/checkbox-list/checkbox-list.module';
import { DragDropGroupsModule } from '../../shared/drag-drop-groups/drag-drop-groups.module';
import { EventsModule } from '../../technical-modules/events/event-bus.module';
import { FilterableSelectModule } from '../../shared/filterable-select/filterable-select.module';
import { JSR310LocalDatesModule } from '../../shared/jsr310-localdates/jsr310-localdates.module';
import { PannelModule } from '../../shared/pannel/pannel.module';
import { SuggestableInputModule } from '../../shared/suggestable-input/suggestable-input.module';
import { TabsModule } from '../../shared/tabs/tabs.module';

// Composants metiers
import { AnalyseGlobalePdpComponent } from './components/pdp/analyse-globale-pdp.component';
import { CommunicationMutuelleInfoComponent } from "./components/pdp/communication-mutuelle-info.component";
import { ConsignesSecuriteGeneralesComponent } from './components/pdp/consignes-securite-generales.component';
import { FinalisationPdpComponent } from './components/pdp/finalisation-pdp.component';
import { ImpressionPdPDialogComponent } from './components/pdp/impression-pdp-dialog.component';
import { InfoGeneralesComponent } from "./components/pdp/info-generales.component";
import { GestionSignaturePdpSpecifiqueComponent } from './components/pdp/gestion-signature-pdp-specifique.component';
import { GestionSignaturePdpGeneralComponent } from './components/pdp/gestion-signature-pdp-general.component';
import { PdpManageIntervenantComponent } from './components/pdp/pdp-manage-intervenants.component';
import { PdpManageLinkComponent } from './components/pdp/pdp-manage-link.component';
import { PdpResumeComponent } from './components/pdp/pdp-resume.component';
import { PdpGenerationComponent } from './components/pdp/pdp-generation.component';
import { PlanPreventionDetailsComponent } from "./components/pdp/plan-prevention-details.component";
import { SignatairesDialogComponent } from "./components/signataires-dialog.component";
import { DocusignEnveloppeDialogComponent } from './components/pdp/docusign-enveloppe-dialog.component';
import { GestionPlanPreventionsComponent } from './components/pdp/gestion-plan-prevention.component';
import { ListePlanPreventionsComponent } from './components/pdp/liste-plan-preventions.component';
import { PdpSearchComponent } from './components/pdp/pdp-search.component';
import { PdpValidationRefreshComponent } from './components/pdp/pdp-validation-refresh.component';

import { DocumentSecuriteComponent } from './components/document-securite.component';

import { ListeDocumentPaComponent } from './components/pa/liste-documents-pa.component';
import { GestionDocumentPaComponent } from './components/pa/gestion-documents-pa.component';
import { DocumentsPaSearchComponent } from './components/pa/documents-pa-search.component';
import { DocumentsPaStepperPvComponent } from './components/pa/documents-pa-stepper-pv.component';
import { DocumentsPaStepperEolComponent } from './components/pa/documents-pa-stepper-eol.component';
import { DocumentPaDefinitionComponent } from './components/pa/document-pa-definition.component';
import { DocumentPaEntreprisesComponent } from './components/pa/document-pa-entreprises.component';
import { DocumentPaStepActionsComponent } from './components/pa/document-pa-step-actions.component';
import { DocumentPaConsignesGenerales } from './components/pa/document-pa-consignes-generales.component';
import { ConsignesPvComponent } from './components/pa/consignes-pv.component';
import { AnalyseRisquesGeneriquePaComponent } from './components/pa/analyse-risque-generique-pa.component';
import { DocumentPaConsignesSecurite } from './components/pa/document-pa-consignes-securite.component';
import { DocumentPaEchange } from './components/pa/document-pa-echange.component';
import { DocumentPaValidationSignatureComponent } from './components/pa/document-pa-validation-signature.component';
import { PaResumeComponent } from './components/pa/pa-resume.component';
import { PaGenerationComponent } from './components/pa/pa-generation.component';
import { PaManageLinkComponent } from './components/pa/pa-manage-link.component';
import { GestionSignaturePaComponent } from './components/pa/gestion-signature-pa.component';
import { PaManageIntervenantComponent } from './components/pa/pa-manage-intervenants.component';

// Services metier
import { PlanPreventionService } from './services/plan-prevention.service';
import { TraductionPdpService } from './services/traduction-pdp.service';
import { ConsignesSecuriteGeneralesService } from './services/consignes-securite-generales.service';
import { CommunicationMutuelleInfoService } from './services/communication-mutuelle-info.service';
import { DocumentPaService } from './services/document-pa-service';

// routage entre tabs

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		
		MatCheckboxModule,
		MatDialogModule,
		MatInputModule,
		MatRadioModule,
		MatStepperModule,
		MatTableModule,
		MatSortModule,
		MatPaginatorModule,
		MatProgressBarModule,
		
		NgxFileDropModule,
		
		AgenceModule,
		AntenneModule,
		GroupementParcModule,
		ParcModule,
		OuvrageModule,
		
		BootstrapPopupModule,
		CheckboxListModule,
		DragDropGroupsModule,
		EventsModule,
		FilterableSelectModule,
		JSR310LocalDatesModule,
		PannelModule,
		TabsModule,
		SuggestableInputModule,
		FiltersModule,
		FormattersModule
	],
	providers: [
		PlanPreventionService,
		TraductionPdpService,
		DocumentPaService,
		CommunicationMutuelleInfoService,
		ConsignesSecuriteGeneralesService,
	],
	declarations: [
		AnalyseGlobalePdpComponent,
		CommunicationMutuelleInfoComponent,
		ConsignesSecuriteGeneralesComponent,
		FinalisationPdpComponent,
		ImpressionPdPDialogComponent,
		InfoGeneralesComponent,
		GestionSignaturePdpSpecifiqueComponent,
		GestionSignaturePdpGeneralComponent,
		PdpManageIntervenantComponent,
		PdpManageLinkComponent,
		PdpResumeComponent,
		PdpGenerationComponent,
		PlanPreventionDetailsComponent,
		SignatairesDialogComponent,
		DocusignEnveloppeDialogComponent,
		GestionPlanPreventionsComponent,
		ListePlanPreventionsComponent,
		PdpSearchComponent,
		PdpValidationRefreshComponent,
		ListeDocumentPaComponent,
		DocumentSecuriteComponent,
		DocumentPaStepActionsComponent,
		GestionDocumentPaComponent,
		DocumentsPaSearchComponent,
		DocumentsPaStepperPvComponent,
		DocumentsPaStepperEolComponent,
		DocumentPaDefinitionComponent,
		DocumentPaEntreprisesComponent,
		DocumentPaConsignesGenerales,
		ConsignesPvComponent,
		AnalyseRisquesGeneriquePaComponent,
		DocumentPaConsignesSecurite,
		DocumentPaEchange,
		DocumentPaValidationSignatureComponent,
		PaResumeComponent,
		PaGenerationComponent,
		PaManageLinkComponent,
		GestionSignaturePaComponent,
		PaManageIntervenantComponent
	],
	entryComponents: [
		GestionSignaturePdpGeneralComponent,
		GestionSignaturePdpSpecifiqueComponent,
		PdpManageIntervenantComponent,
		PdpManageLinkComponent,
		PdpResumeComponent,
		PdpGenerationComponent,
		PdpValidationRefreshComponent
	]
})
export class DocumentSecuriteModule {
	constructor() { }
}
